import React, { Component } from "react";
import PropTypes from "prop-types";
import { Nav, NavbarToggler, NavItem, NavLink } from "reactstrap";
import HeaderDropdown from "./HeaderDropdown";
import CompanyName from "../CompanyName";

class Header extends Component {
  constructor(props) {
    super(props);
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-minimized");
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("aside-menu-hidden");
  }

  render() {
    return (
      <header className="app-header navbar" style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        borderBottom: "none",
        boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3)",
        padding: "0 15px"
      }}>
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}
          style={{ borderColor: "rgba(255,255,255,0.3)" }}>
          <span className="navbar-toggler-icon" style={{ filter: "brightness(10)" }} />
        </NavbarToggler>
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}
          style={{ borderColor: "rgba(255,255,255,0.3)" }}>
          <span className="navbar-toggler-icon" style={{ filter: "brightness(10)" }} />
        </NavbarToggler>
        <Nav style={{ color: "#FFFFFF", alignItems: "center" }}>
          <span style={{
            fontSize: "18px",
            fontWeight: "700",
            letterSpacing: "0.5px",
            textShadow: "0 2px 4px rgba(0,0,0,0.2)"
          }}>
            <i className="fa fa-book" style={{ marginRight: "10px" }}></i>
            BizBooks
          </span>
          <span style={{
            marginLeft: 12,
            fontSize: "14px",
            opacity: 0.9,
            fontWeight: "500"
          }}>
            <CompanyName fallback="" />
          </span>
        </Nav>
        <Nav className="ml-auto" navbar style={{ alignItems: "center" }}>
          <HeaderDropdown accnt />
        </Nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js